import { render } from "./Code.vue?vue&type=template&id=6c439c65"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/icons/Code.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c439c65"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c439c65', __exports__)) {
    api.reload('6c439c65', __exports__)
  }
  
  module.hot.accept("./Code.vue?vue&type=template&id=6c439c65", () => {
    api.rerender('6c439c65', render)
  })

}


export default __exports__